import React from 'react'

export default (props) => {
  return (
    <div className="custom-control custom-switch custom-switch-on-success" style={{
      opacity: props.viewOnly ? 0.6 : 1,
      pointerEvents: props.viewOnly ? 'none' : 'auto'
    }}>
      <input disabled={props.viewOnly} type="checkbox" onChange={(t) => {
        props.onChangeText(props.prop, t.target.checked == true)
      }} checked={!!props.value} className="custom-control-input" id={props.prop} />
      <label className="custom-control-label" htmlFor={props.prop} style={{
        cursor: props.viewOnly ? 'default' : 'pointer'
      }}>{props.header}</label>
    </div>);
}